import {
    appId,
    token,
    browserEnterToken,
    browserEnterAppId,
    shareAppId,
    shareToken,
    browserSimpleAppId,
    browserSimpleToken,
} from './conf';
import {
    Utils__getImeiMd5,
    Utils__getFakeImeiMd5,
    Utils__random,
    Utils__param,
    Utils__getDeviceInfo,
    Utils__getUserAccountInfo,
    Utils__isMiuiBrowser,
    Utils__isXiangkan,
    Utils__getNativeDeviceId,
    Utils__isSimpleHome,
} from './utils';
import { api__stats } from "./api";

const stats__sessionTimeout = 30 * 60 * 1000;
const stats__sessionIdKey = 'xiangkanStatsSessionId';
const stats__sessionTimeKey = 'xiangkanStatsSessionTime';

function stats__getSessionId() {
    const now = Date.now();
    const sessionId = sessionStorage[stats__sessionIdKey];
    const lastTime = parseInt(sessionStorage[stats__sessionTimeKey]);

    sessionStorage[stats__sessionTimeKey] = now;

    if (sessionId && lastTime && now >= lastTime && now <= lastTime + stats__sessionTimeout) {
        return sessionId;
    }

    return (sessionStorage[stats__sessionIdKey] = Utils__random('0123456789abcdef', 32));
}

function stats__getO2oAppIdToken() {
    const UA = navigator.userAgent || '';

    if (Utils__isMiuiBrowser(UA)) {
        if (Utils__isSimpleHome()) { // 浏览器简洁版
            return {
                appId: browserSimpleAppId,
                token: browserSimpleToken,
            }
        } else {
            return {
                appId: browserEnterAppId,
                token: browserEnterToken,
            }
        }
    } else if (Utils__isXiangkan(UA)) {
        return {
            appId: appId,
            token: token,
        }
    } else {
        return {
            appId: shareAppId,
            token: shareToken,
        }
    }

}

export default function stats__send(args, success, error) {
    let appIdToken = stats__getO2oAppIdToken(),
        baseArgs = {
            _id: stats__getSessionId(),
            cdt: Date.now(),
            app_id: args.appId || appIdToken.appId,
            token_auth: args.token || appIdToken.token,
            did: Utils__getFakeImeiMd5() || Utils__getImeiMd5(),
            e_c: args.cate,
            e_a: args.action,
            e_n: args.name,
            e_x: args.ext,
            path: args.path,
        };

    const deviceInfo = Utils__getDeviceInfo();
    const userAccountInfo = Utils__getUserAccountInfo() || {};

    if (deviceInfo) {
        baseArgs = {
            ...baseArgs,
            res: deviceInfo.screen_width + 'x' + deviceInfo.screen_height,
            ua: 'MiuiBrowser (Linux; U; Android ' + deviceInfo.version_release + '; ' + deviceInfo.model + ' MIUI/' + deviceInfo.version_incremental + ')',
            lang: deviceInfo.language && deviceInfo.language.split('-')[0],
            did: Utils__getNativeDeviceId(),
            oaid: deviceInfo.oaId || deviceInfo.oaid,
            country: deviceInfo.region,
            cv: deviceInfo.version_name,
            uid: userAccountInfo.user_id || '',
            channel: deviceInfo.channel || '',
            model: deviceInfo.model || '',
            os_version: deviceInfo.os_version || '',
        }
    }

    const data = Utils__param({
        requests: JSON.stringify({
            requests: ['?' + Utils__param(baseArgs)],
            token_auth: baseArgs.token_auth,
        })
    });

    console.log('track', baseArgs);
    return api__stats(data, success, error);
}
